import { ADD_BANK_ACCOUNT_PARCHI } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

interface Request {
    account_type: string;
    account_details: {
        name?: string;
        ifsc?: string;
        account_number?: string;
        address?: string;
        account_type?: string;
    };
    oid?: string;
}

export interface Root {
    success: boolean;
    response: Response;
}

export interface Response {
    fund_acc_id: string;
    validation_status: string;
    error?: {
        code: string;
        description: string;
        reason: string;
        field: string;
    };
}

export default (request: Request): Promise<Root> => {
    return fetchWithRefresh(ADD_BANK_ACCOUNT_PARCHI, {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-Type': 'application/json',
        },
    }).then((res) => res.json());
};
